<template>
  <section>
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-input v-model="filters.name" placeholder="消息标题" style="width:300px;" icon="circle-close"
                    :on-icon-click="cleanFilter"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-on:click="getMessages">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd">新增</el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <!--列表-->
    <el-table :data="messages" border highlight-current-row v-loading="listLoading"
              style="width: 100%;">
      <el-table-column header-align="center" prop="title" label="标题" align="center" min-width="150">
      </el-table-column>
      <el-table-column header-align="center" prop="content" label="内容" min-width="300">
      </el-table-column>
      <el-table-column prop="createdAt" label="创建时间" :formatter="formatTime" width="120" align="center">
      </el-table-column>
      <el-table-column label="操作" width="150" align="center">
        <template scope="scope">
          <el-button size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button v-if="me.rname === 'ROLE_ADMIN'" type="danger" size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="10" :total="total"
                     style="float:right;">
      </el-pagination>
    </el-col>

    <!--编辑界面-->
    <el-dialog title="编辑" v-model="editFormVisible" :close-on-click-modal="false">
      <el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">
        <el-form-item label="消息标题" prop="title">
          <el-input v-model="editForm.title" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="消息内容" prop="content">
          <el-input type="textarea"
                    :rows="8" v-model="editForm.content"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog title="新增通知" v-model="addFormVisible" :close-on-click-modal="false">
      <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
        <el-form-item label="消息标题" prop="title">
          <el-input v-model="addForm.title" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="消息内容" prop="content">
          <el-input type="textarea"
                    :rows="8" v-model="addForm.content"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
      </div>
    </el-dialog>

  </section>
</template>

<script>
  import util from '../../common/js/util'
  import moment from 'moment'
  import bcrypt from 'bcryptjs'
  //import NProgress from 'nprogress'
  import {getMessageList, addMessage, editMessage, removeMessage} from '../../api/api';

  export default {
    data() {
      return {
        filters: {
          name: ''
        },
        me: JSON.parse(sessionStorage.getItem('user')),
        messages: [],
        total: 0,
        page: 1,
        listLoading: false,
        editLoading: false,
        editFormRules: {
          title: [
            {required: true, message: '请输入消息标题', trigger: 'blur'},
          ],
          content: [
            {required: true, message: '请输入消息内容', trigger: 'blur'},
          ],
        },
        //编辑界面数据
        editForm: {
          id: '',
          title: '',
          content: '',
        },

        addFormVisible: false,//新增界面是否显示
        editFormVisible: false,//新增界面是否显示
        addLoading: false,
        addFormRules: {
          title: [
            {required: true, message: '请输入消息标题', trigger: 'blur'},
          ],
          content: [
            {required: true, message: '请输入消息内容', trigger: 'blur'},
          ],
        },
        //新增界面数据
        addForm: {
          title: '',
          content: '',
        },
      }
    },
    filters: {
      name: ''
    },
    methods: {
      cleanFilter() {
        this.filters.name = '';
        this.getMessages();
      },
      formatTime: function (row, column) {
        return moment(row.createdAt).format('YYYY-MM-DD');
      },
      handleCurrentChange(val) {
        this.page = val;
        this.getMessages();
      },
      //获取企业列表
      getMessages() {
        let para = {
          page: this.page,
          size: 10,
          name: this.filters.name
        };
        this.listLoading = true;
        //NProgress.start();
        getMessageList(para).then((res) => {
          this.total = res.data.total;
          this.messages = res.data.list;
          this.listLoading = false;
          //NProgress.done();
        });
      },
      //删除
      handleDel: function (index, row) {
        this.$confirm('确认删除该记录吗?', '提示', {
          type: 'warning'
        }).then(() => {
          this.listLoading = true;
          //NProgress.start();
          removeMessage(row.id).then((res) => {
            this.listLoading = false;
            //NProgress.done();
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.getMessages();
          });
        }).catch(() => {

        });
      },
      //显示编辑界面
      handleEdit: function (index, row) {
        this.editFormVisible = true;
        this.editForm = Object.assign({}, row);
      },
      //显示新增界面
      handleAdd: function () {
        this.addFormVisible = true;
        if (this.$refs['addForm']) {
          this.$refs['addForm'].resetFields();
        }
        this.addForm = {
          title: '',
          content: '',
        };
      },
      //编辑
      editSubmit: function () {
        this.$refs.editForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.editLoading = true;
              //NProgress.start();
              let para = {
                id: this.editForm.id,
                title: this.editForm.title,
                content: this.editForm.content,
              };
              editMessage(para).then((res) => {
                this.editLoading = false;
                //NProgress.done();
                this.$message({
                  message: '提交成功',
                  type: 'success'
                });
                this.$refs['editForm'].resetFields();
                this.editFormVisible = false;
                this.getMessages();
              });
            });
          }
        });
      },
      //新增
      addSubmit: function () {
        this.$refs.addForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.addLoading = true;
              //NProgress.start();
              let para = Object.assign({}, this.addForm);
              addMessage(para).then((res) => {
                this.addLoading = false;
                //NProgress.done();
                this.$message({
                  message: '提交成功',
                  type: 'success'
                });
                this.$refs['addForm'].resetFields();
                this.addFormVisible = false;
                this.getMessages();
              });
            });
          }
        });
      },
    },
    mounted() {
      this.getMessages();
    }
  }

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Notice.vue?3913c0d2